import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

import { AuthenticationService } from '../../auth/services';
import { SettingService } from '../services';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private settingService: SettingService) {}

  canActivate() {
    const user = this.settingService.user;
    if (user && typeof user.accessToken === 'string') {
      return true;
    }
    this.router.navigate(['/auth/login']);
    return false;
  }
}
